module.exports = __webpack_public_path__ + "static/media/Makuhita_gaussian2.d1906224.png";